import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/zakaznici',
    name: 'customers',
    meta: { moduleId: 'customers' },
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customers/Index.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/zakaznici/vytvorit/:id?',
    name: 'customers.create',
    meta: { moduleId: 'customers' },
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customers/Create.vue'),
    beforeEnter: isAuthenticated,
  },
];
